import { render, staticRenderFns } from "./MegaMenu.vue?vue&type=template&id=3566eec8"
import script from "./MegaMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MegaMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MegaMenu.vue?vue&type=style&index=0&id=3566eec8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports